import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const archiveTaskType = ({ _id }: { _id: string }): Promise<void> => {
  return axios.post(`/task-types/${_id}/archive`);
};

type UseArchiveTaskTypeOptions = {
  config?: MutationConfig<typeof archiveTaskType>;
};

const TOAST_ID = 'archive-task-type';

export const useArchiveTaskType = ({ config = {} }: UseArchiveTaskTypeOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['task-types']);
      toasts.loadingToast.success(TOAST_ID, 'Task type archived');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Archiving...');
      config.onMutate?.(...args);
    },
    mutationFn: archiveTaskType,
  });
};
